import { render } from "./NewsEdit.vue?vue&type=template&id=57d40e4a&scoped=true"
import script from "./NewsEdit.vue?vue&type=script&lang=js"
export * from "./NewsEdit.vue?vue&type=script&lang=js"

import "./NewsEdit.vue?vue&type=style&index=0&id=57d40e4a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d40e4a"]])

export default __exports__